import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i1 from '@angular/cdk/platform';
import * as i2 from '@angular/cdk/layout';

class Platform {
    constructor(
    // Dependencies
    cdkPlatform, breakpointObserver) {
        this.cdkPlatform = cdkPlatform;
        this.breakpointObserver = breakpointObserver;
        // Whether the main input device is not a hover device.
        // Typically this means it's a touch devices.
        this.touchIsMainInput$ = new BehaviorSubject(false);
        // Copying these values from the Angular CDK's Platform object, rather
        // than using the CDK's service directly, in case we eventually need to
        // change the detection implementation.
        this.isBrowser = this.cdkPlatform.isBrowser;
        this.isAndroid = this.cdkPlatform.ANDROID;
        this.isIOS = this.cdkPlatform.IOS;
        this.isBlink = this.cdkPlatform.BLINK;
        this.isWebkit = this.cdkPlatform.WEBKIT;
        this.isEdge = this.cdkPlatform.EDGE;
        this.isFirefox = this.cdkPlatform.FIREFOX;
        this.isSafari = this.cdkPlatform.SAFARI;
        this.platformTokensBS$ = new BehaviorSubject([
            this.isAndroid && 'android',
            this.isIOS && 'ios',
            this.isBlink && 'blink',
            this.isWebkit && 'webkit',
            this.isEdge && 'edge',
            this.isFirefox && 'firefox',
            this.isSafari && 'safari',
        ]
            .filter(v => v));
        this.platformTokens$ = this.platformTokensBS$.asObservable();
        this.breakpointObserver.observe('(hover: none)')
            .subscribe((breakpointState) => this.touchIsMainInput$.next(breakpointState.matches));
        document.documentElement.classList.add(...this.platformTokensBS$.value);
        document.body.classList.add(...this.platformTokensBS$.value);
    }
}
Platform.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: Platform, deps: [{ token: i1.Platform }, { token: i2.BreakpointObserver }], target: i0.ɵɵFactoryTarget.Injectable });
Platform.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: Platform, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.2", ngImport: i0, type: Platform, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.Platform }, { type: i2.BreakpointObserver }]; } });

/*
 * Public API Surface of angular-platform
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Platform };
